<template>
  <div class="wholeImg">
    <!-- 图片点击放大 -->
    <div class="popup-wrap">
      <!-- 轮播图 -->
      <el-carousel class="swipe" indicator-position="none" arrow="always" :autoplay=false ref="carousel" v-if="(olonkList != null && olonkList.length != 0)">
        <el-carousel-item class="swipe-item" v-for="(item, index) in olonkList" :key="index">
          <!-- 下标 -->
          <div class="header">{{index+1}} / {{total}}</div>
          <!-- 大图 -->
          <img class="bigImg" :src="item"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 缩略图scroll -->
    <div class="photos-wrap">
      <div class="img-item" v-for="(item, index) in photos" :key="index" @click="enlarge(index)">
        <img :src="item"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {getFilmDetail} from '@/api/film'
  export default {
    data(){
      return{
        //影片id
        mid: this.$route.query.mid,
        //张数
        total: 0,
        // 所有剧照
        photos: [],
        // 剧照大图
        olonkList: [],
        // 当前大图下标
        currentIndex: '',
        // 当前大图
        currentImg: ''
       }
    },
    // 初始化
    mounted() {
      this.$nextTick(function(){
        //保证this实例已经插入文档
        // 获取剧照数据
        this.getFilmDetail();
      })
    },
    methods: {
      // 获取剧照数据
      getFilmDetail() {
      	let signdata = {mid: this.mid};
        let data = {mid: this.mid, signdata: signdata};
        getFilmDetail(data).then(response => {
          this.photos = response.data.tlinkList;
          this.olonkList = response.data.olonkList;
          this.total = response.data.tlinkList.length;
        });
      },
      // 放大(绑定组件ref="carousel" 手动切换幻灯片 参数：需要切换的幻灯片的索引)
      enlarge(index){
        this.$refs.carousel.setActiveItem(index);
      },
      // 返回上一页
      goBack(){
        this.$router.go(-1);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .wholeImg{
    position: relative;
    height: 100%;
    background: #000;
  }
  .photos-wrap{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: top;
    justify-content: space-between;
    margin-top: 50px;
    padding: 0 15px 15px 15px;
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    box-sizing: border-box;
  }
  .img-item{
    float: left;
    margin: 8px;
    width: 156px;
    height: 100px;
    font-size: 0;
  }
  .img-item img{
    display: inline-block;
    width: 156px;
    height: 100px;
  }
  .popup-wrap{
    width: 100%;
    height: 500px;
    background: black;
  }
  .popup-wrap .swipe{
    margin: 0 auto;
    width: 800px;
    height: 500px;
  }
  .popup-wrap .header{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
  }
  .popup-wrap .bigImg{
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50%;
    width: 800px;
    height: 530px;
    background-size: 100% 100%;
  }
  .swipe-item{
    height: 500px !important;
  }
  .wholeImg .el-carousel__arrow{
    top: 290px !important;
    width: 50px !important;
    height: 50px !important;
    font-size: 36px;
    font-weight: 700;
    background-color: rgba(31,45,61,.4) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/wholeImg.vue